<template>
  <div class="dropdown-fb-control">
    <b-form-group
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
    </b-form-group>
    <div v-if="showType == 'properties'">
      <dropdown-v2-properties :formId="formId" />
    </div>
    <b-form-group
      style="font-size: 14px"
      v-if="
        (showType == 'form-submitter' && page == currentPage) ||
          (showType == 'e-form' && properties.eFormEditable)
      "
      :description="
        computedConditions.description
          ? computedPropertiesForm.description
          : properties.description
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <v-select
        v-model="controlValue"
        style="font-size: 14px"
        :style="
          `--bg-color:${properties.pickerBgColor ? properties.pickerBgColor : 'white'};`
        "
        append-to-body
        :options="[
          ...computedPropertiesForm.options ?? [],
          ...(properties.includeOther ? ['Other'] : [])
        ]"
        :calculate-position="withPopper"
        :multiple="properties.multiselect"
        :autoscroll="false"
      ></v-select>
      <b-form-input
        class="mt-2"
        v-if="controlValue == 'Other'"
        placeholder="Type value..."
        v-model="localValueOther"
        @blur="controlValueOther = localValueOther"
      ></b-form-input>
    </b-form-group>
    <b-form-group
      v-if="
        showType == 'form-viewer' ||
          (showType == 'e-form' && !properties.eFormEditable)
      "
      :label="
        computedConditions.label
          ? computedPropertiesForm.label
          : properties.label
      "
    >
      {{ controlValueText }}
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import DropdownV2Properties from "./DropdownV2Properties.vue";
import { createPopper } from '@popperjs/core'
export default {
  name: "DropdownV2",
  components: { DropdownV2Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      computedProperties: ["description", "label", "hidden", "options"],
      computedConditions: {},
      localValueOther: ""
    };
  },
  mounted() {
    this.localValueOther = this.controlValueOther;
    if (this.showType == "form-submitter" || this.showType == "e-form") {
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          label: this.properties.label
        }
      });
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    }

    this.computeConditions();
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      dropdownList.style.zIndex = 9999;
      
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: 'bottom',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                  'drop-up',
                  state.placement === 'top'
              )
            },
          },
        ],
      })
      return () => popper.destroy()
    },
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true || this.properties.hideOnView)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
          ${
            this.controlValue != "Other"
              ? (this.controlValue ? this.controlValue : "")
              : this.controlValueOther
          }
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        let value = null;
        if (this.results) value = this.results[this.id];
        else value = this.getFormSubmitterComponentValue(this.id);
        value = value || {
          value: null,
          otherValue: ""
        };
        return value.value;
      },
      set(newControlValue) {
        if (this.controlValue != newControlValue) {
          const newValue = {
            value: newControlValue,
            otherValue: this.controlValueOther
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newValue,
            userAction: true,
            hardSet: this.properties.resetStoreValues
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newValue
          });
          if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                newControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
        }
      }
    },
    controlValueOther: {
      get() {
        let value = null;
        if (this.results) value = this.results[this.id];
        else value = this.getFormSubmitterComponentValue(this.id);
        value = value || {
          value: null,
          otherValue: ""
        };
        return value.otherValue;
      },
      set(newControlValue) {
        if (this.controlValueOther != newControlValue) {
          const newValue = {
            value: this.controlValue,
            otherValue: newControlValue
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: newValue,
            userAction: true,
            hardSet: this.properties.resetStoreValues
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: newValue
          });
        }
      }
    },
    controlValueText() {
      if(this.controlValue != "Other" &&
        this.controlValue &&
        Array.isArray(this.controlValue))
        return this.controlValue.join(", ")
      
      if(this.controlValueOther)
        return this.controlValueOther

      return this.controlValue
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  },
  watch: {
    controlValueOther(newValue) {
      if (newValue != this.localValueOther) {
        this.localValueOther = newValue;
      }
    }
  }
};
</script>

<style>
.vs__dropdown-menu {
  li {
    white-space: normal;
  }
}
.dropdown-fb-control .vs__dropdown-toggle {
  background-color: var(--bg-color) !important;
}
</style>
